import { useEffect, useState } from "react";

// Re-renders the caller once a minute so "Starts in 2h 15m" stays honest while
// the page sits open. Minute granularity only — the countdowns never show
// seconds, so a faster timer would just burn renders.
const useMinuteTick = (enabled = true) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const id = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(id);
  }, [enabled]);
};

export default useMinuteTick;
